<template>
  <div class="input-container">
    <input
      v-if="edit"
      ref="input"
      v-model="localValue"
      type="date"
      @blur="edit = false"
      @keyup.enter="edit = false"
      @keydown.tab="next"
    >
    <div
      v-else
      :class="{error, filled: value, disabled}"
      class="placeholder"
      @click="startEdit"
    >
      {{ placeholder }}
    </div>
    <div
      v-for="(message, i) in invalidFeedback"
      :key="`err-${i}`"
      class="error-text"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
const MONTH_LABELS = {
  '01': 'января',
  '02': 'февраля',
  '03': 'марта',
  '04': 'апреля',
  '05': 'мая',
  '06': 'июня',
  '07': 'июля',
  '08': 'августа',
  '09': 'сентября',
  '10': 'октября',
  '11': 'ноября',
  '12': 'декабря',
}
export default {
  name: 'FormDocInputDate',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    disabled: {type: Boolean},
    invalidFeedback: {
      type: Array,
      default () {
        return []
      },
    },
    value: {type: String, default: ''},
  },
  data () {
    return {
      edit: false,
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('change', value)
      },
    },
    placeholder () {
      if (this.value) {
        let [, year, month, day] = this.value.match(/(\d{4})-(\d{2})-(\d{2})/)
        return `«${day}» ${MONTH_LABELS[month]} ${year} г.`
      } else {
        return '«___» _______ 20__ г.'
      }
    },
    error () {
      return this.invalidFeedback.length > 0
    },
  },
  methods: {
    startEdit () {
      if (!this.disabled) {
        this.edit = true
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      }
    },
    next (e) {
      console.log('tab', e)
      e.preventDefault()
    },
  }
}
</script>

<style lang="scss" scoped>
  .input-container {
    display: inline-flex;
    flex-direction: column;
  }
  .error-text {
    color: var(--v-error-base) !important;
    font-size: 0.625rem;
    font-family: $body-font-family;
    font-weight: normal;
  }

  input {
    background-color: white;
    border: 1px solid #999;
    border-radius: 3px;
    padding: 1px 0.25rem;
    line-height: 1;
  }
  .placeholder {
    color: #aaa;
    background-color: #fcffaa;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 1px 0.25rem;
    cursor: pointer;
  }
  .filled {
    color: black;
    background-color: #fcffaa;
    border: none;
  }
  .disabled {
    color: black;
    background-color: #ddd;
    border: none;
    cursor: not-allowed;
  }
  .error {
    color: var(--v-error-base) !important;
    background-color: #ffddcc !important;
    border-color: var(--v-error-base) !important;
  }
</style>
